import { useConsignadoINSS } from './hook/useConsignadoINSS';
import Faq from '../../components/faq/Faq';
import Layout from '../../components/layout/Layout';
import { AboutConsignadoINSS } from './AboutConsignadoINSS';
import ConsignadoInfo from './ConsignadoInfo';
import HowSolicitationConsignadoINSS from './HowSolicitationConsignadoINSS';
import { PersonalDataModal } from '../../components/modal/personalDataModal/PersonalDataModal';

function ConsignadoINSS() {

    const {
        faqs,
        getSubHeader,
        cpf,
        setCpf,
        personalDataModalRef,
        onGoToRegister
    } = useConsignadoINSS();

    return (
        <Layout
            subHeader={getSubHeader()}
        >
            <PersonalDataModal
                ref={personalDataModalRef}
            />
            <AboutConsignadoINSS
                setCpf={setCpf}
                cpf={cpf}
                openPersonalDataModal={onGoToRegister}
            />
            <ConsignadoInfo
                openPersonalDataModal={onGoToRegister}
            />
            <HowSolicitationConsignadoINSS
                onGoToRegister={onGoToRegister}
                openPersonalDataModal={onGoToRegister}
            />
            <Faq
                faqs={faqs}
                title='Tire suas dúvidas sobre o Empréstimo Consignado Bmg'
            />
        </Layout>
    );
}

export default ConsignadoINSS;